import axios from 'axios'
import config from '@/config/env'

const { API_URL } = config

export const loadAgents = (params) => {
  let sort = `desc(dateentry)`
  if (params?.sort) {
    sort = params.sort
  }
  return axios.get(API_URL + '/pntagent', {
    params: { ...params, sort },
  })
}

export const loadAgent = (idagent) => {
  return axios.get(API_URL + '/pntagent', {
    params: {
      querysearch: `idagent:eq(${idagent})`,
      fetch: 'iduser',
    },
  })
}

export const whoAmI = () => {
  return axios.get(API_URL + '/pntagent/whoami')
}

export const register = (agent) => {
  return axios.post(API_URL + '/pntagent/register', agent)
}

export const update = (agent) => {
  return axios.put(API_URL + '/pntagent', agent)
}

export const getCommercial = () => {
  return axios.get(API_URL + '/pntagent/getcommercial')
}

export const updateRol = (roles, iduser) => {
  return axios.post(API_URL + `/pntagent/updateagentroles/${iduser}`, roles)
}

export const resetAgentPass = (iduser) => {
  return axios.post(API_URL + `/pntagent/resetagentpass/${iduser}`)
}

export const api = {
  loadAgents,
  loadAgent,
  whoAmI,
  register,
  update,
  getCommercial,
  updateRol,
  resetAgentPass,
}

export default api
